import React from 'react';
import { FormattedMessage } from 'react-intl';
import { func, object } from 'prop-types';
import InlineError from '../Forms/InlineError';

const propTypes = {
  submit: func.isRequired,
  change: func.isRequired,
  data: object.isRequired,
  errors: object,
};

const defaultProps = {
  submit() {},
  change() {},
  data: {},
  errors: {},
};

const AffiliatePasswordRecoveryForm = ({ submit, change, data, errors }) => (
  <form onSubmit={submit} autoComplete="off">
    <div className={errors.email ? 'form-group has-error' : 'form-group'}>
      <label htmlFor="email" className={!data.email ? 'label' : 'label label-upper'}>
        <FormattedMessage id="password.recovery.field.email" defaultMessage="Email" />
      </label>
      <input
        id="email"
        className="form-control"
        type="email"
        name="email"
        value={data.email}
        onChange={change}
        tabIndex="1"
        autoFocus
        required
      />
      {errors.email && <InlineError text={errors.email} />}
    </div>

    <div className="form-controls">
      <button type="submit" className="btn btn-primary btn-block" tabIndex="3">
        <FormattedMessage id="password.recovery.field.send" defaultMessage="Send" />
      </button>
    </div>
  </form>
);

AffiliatePasswordRecoveryForm.propTypes = propTypes;
AffiliatePasswordRecoveryForm.defaultProps = defaultProps;

export default AffiliatePasswordRecoveryForm;
